import React from 'react'

function Cruise() {
  return (
    <div>Cruise</div>
  )
}

export default Cruise